import { asyncType, stepType } from "redux/types/asyncTypes";
export const SIGN_IN_AFF = asyncType("SIGN_IN_AFF");
export const SIGN_UP_STEP = stepType("SIGN_UP_STEP");
export const SIGN_UP_AFF = asyncType("SIGN_UP_AFF");
export const SETUP_PROFILE_THREE = "SETUP_PROFILE_THREE";
export const SETUP_PROFILE_TWO = "SETUP_PROFILE_TWO";
export const COMPLETE_SETUP = asyncType("COMPLETE_SETUP");
export const SIGN_OUT_AFF = "SIGN_OUT_AFF";
export const LOGIN_AFF = "LOGIN_AFF";
